var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rtl overflow-y-scroll"},[_c('app-list',{ref:"list",staticClass:"ltr",attrs:{"searchable":!_vm.isInvestor(),"searching":_vm.searching},on:{"search":_vm.onSearch},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }